module.exports = __webpack_public_path__ + "officialStatic/img/productDl.9aabea7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/productDl.png
// module id = oKEa
// module chunks = 0